<mat-card appearance="outlined" class="px-3 profile-card">
  <div class="title">
    <img src="../../../../../assets/images/icons/icon_apartment.svg" />
    <h4>Company Info</h4>
  </div>
  <hr class="mt-1" />
  @if (companyDataExists) {
    <div class="row">
      <div class="col-6 key-value">
        <label>NAME</label>
        <p>{{ companyDescription }}</p>
      </div>
      <div class="col-6 key-value">
        <label>ENABLED SERVICES</label>
        <p>{{ companyEnabledServices }}</p>
      </div>
    </div>
  }
  @if (!companyDataExists) {
    <p>Error retrieving company data</p>
  }
</mat-card>
